import {
  Topic,
  GeoEventEvacZoneStatus,
  FormEvacZoneStatus,
  ReportAsset,
} from 'shared/types';
import { NotificationType } from 'features/notifications/notifications.types';
import { AlertCamera } from 'features/cameras/cameras.types';
import { GeoEventRegion } from './geoEventRegion.types';
import { GeoEventTypes, ReportableGeoEventTypes } from '../../constants';

export type GenericGeoEvent = {
  id: number;
  isActive: boolean;
  isVisible: boolean;
  name: string;
  description: string | null;
  lat: number;
  lng: number;
  address: string | null; // the API can return null for any geo-event type
  geoEventType: GeoEventType;
  dateCreated: Date;
  dateModified: Date;
  notificationType: NotificationType;
  regions: GeoEventRegion[];
  reporterManaged: boolean;
  incidentId: number | null;
  externalId: number | null;
  externalSource: string | null;
  hasReporterNotes?: boolean | null;
  pulsepointReciprocalUrl: string | null;
  createdByName: {
    displayNameShort: string;
    displayName: string | null;
    abbreviationName: string | null;
  };
  topics: Topic[];
  userCreatedId: number;
  evacZoneStatuses: GeoEventEvacZoneStatus[];
};
export type GeoEventType = (typeof GeoEventTypes)[keyof typeof GeoEventTypes];

export type ReportableGeoEventType =
  (typeof ReportableGeoEventTypes)[keyof typeof ReportableGeoEventTypes];

export enum GeoEventUrgencyLevel {
  Stale = 'stale',
  Standard = 'standard',
  Medium = 'medium',
  High = 'high',
  Urgent = 'urgent',
}

export type CreateMediaPayload = {
  url: string | null;
  lat: string | null;
  lng: string | null;
  az: number | null;
  attribution: string | null;
  sourceMediaUrl?: string;
};

export type ReuseMediaPayload = {
  id: number;
};

export type ReportMediaForm = CreateMediaPayload | ReuseMediaPayload;

export type EvacFormValues = {
  activeEvacuations: boolean;
  evacZoneStatuses: FormEvacZoneStatus[];
  temporarilyDisplayEvacZones: boolean;
  customOrders: boolean;
  customWarnings: boolean;
  customAdvisories: boolean;
  customShelterInPlace: boolean;
  evacuationOrders: string;
  evacuationWarnings: string;
  evacuationNotes: string;
  evacuationAdvisories: string;
  evacuationShelterInPlace: string;
  releasePendingZoneUids?: string[];
  unstructuredEvacuationRegionIds: number[];
};

export type ReportFormValues = {
  reportNotificationType: NotificationType;
  reportMessage: string;
  asset: ReportAsset;
  media: File | Blob | AlertCamera | null;
  provisionalSubmissionMediaId?: number | null;
  mediaUrl?: string;
  fileType: string;
  embedUrl: string;
  mediaLat: string;
  mediaLng: string;
  mediaAz: number;
};

export type PendingReviewEvacZoneErrorType =
  | 'not-accepted'
  | 'restricted-with-status';
